"use strict";

class FilterUIManager {
  constructor() {
    this.selectors = {
      details: ".filter-dropdown__details",
      summary: "summary",
      wrapper: ".filter-dropdown",
      popup: ".filter-dropdown__popup"
    };
    this.init();
  }
  init() {
    document.querySelectorAll(this.selectors.details).forEach(details => {
      details.addEventListener("toggle", e => {
        const summary = details.querySelector(this.selectors.summary);
        if (!summary) return;
        summary.setAttribute("aria-expanded", details.open);
      });
    });
    document.addEventListener("click", e => this.handleClick(e));
  }
  handleClick(e) {
    const summary = e.target.closest(this.selectors.summary);
    if (summary) {
      const details = summary.closest(this.selectors.details);
      if (details && !details.hasAttribute("open")) {
        this.closeSiblings(details);
      }
      return;
    }
    const wrapper = e.target.closest(this.selectors.wrapper);
    if (!wrapper) {
      this.closeAll();
    }
  }
  closeSiblings(currentDetails) {
    const allDetails = document.querySelectorAll(this.selectors.details);
    let closed = 0;
    allDetails.forEach(other => {
      if (other !== currentDetails && other.hasAttribute("open")) {
        other.removeAttribute("open");
        closed++;
      }
    });
  }
  closeAll() {
    const allDetails = document.querySelectorAll(this.selectors.details);
    let closed = 0;
    allDetails.forEach(details => {
      if (details.hasAttribute("open")) {
        details.removeAttribute("open");
        closed++;
      }
    });
  }
}
class FilterFlyoutManager {
  constructor() {
    this.selectors = {
      flyoutForm: "[data-filter-form-flyout]",
      clearBtn: '[data-button="clear"]',
      applyBtn: '[data-button="apply"]',
      filterInputs: "input[data-filter-item]",
      hideClass: "hide"
    };
    this.flyoutForm = document.querySelector(this.selectors.flyoutForm);
    if (!this.flyoutForm) {
      return;
    }
    this.init();
  }
  init() {
    this.flyoutForm.addEventListener("change", e => {
      if (e.target.hasAttribute("data-filter-item")) {
        this.handleInputChange(e.target);
      }
    });
    this.flyoutForm.addEventListener("click", e => {
      if (e.target.matches(this.selectors.clearBtn)) {
        this.handleClearClick(e);
      }
    });
    this.updateClearButtonVisibility();
  }
  handleInputChange(input) {
    this.updateClearButtonVisibility();
    this.handleShowAllLogic(input);
  }
  handleShowAllLogic(input) {
    const isResetRadio = input.hasAttribute("data-filter-reset");
    const isFilterCheckbox = input.type === "checkbox" && !isResetRadio && input.name.includes("filter.");
    if (isResetRadio && input.checked) {
      const paramName = input.dataset.paramName;
      const checkboxes = this.flyoutForm.querySelectorAll(`input[type="checkbox"][name="${paramName}"]`);
      checkboxes.forEach(box => {
        box.checked = false;
      });
    }
    if (isFilterCheckbox) {
      const paramName = input.name;
      if (input.checked) {
        const resetBtn = this.flyoutForm.querySelector(`input[data-filter-reset][data-param-name="${paramName}"]`);
        if (resetBtn && resetBtn.checked) {
          resetBtn.checked = false;
          resetBtn.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        }
      } else {
        const remainingChecked = this.flyoutForm.querySelectorAll(`input[type="checkbox"][name="${paramName}"]:checked`).length;
        if (remainingChecked === 0) {
          const resetBtn = this.flyoutForm.querySelector(`input[data-filter-reset][data-param-name="${paramName}"]`);
          if (resetBtn && !resetBtn.checked) {
            resetBtn.checked = true;
            resetBtn.dispatchEvent(new Event("change", {
              bubbles: true
            }));
          }
        }
      }
    }
  }
  updateClearButtonVisibility() {
    const clearBtn = this.flyoutForm.querySelector(this.selectors.clearBtn);
    if (!clearBtn) {
      return;
    }
    const filterInputs = Array.from(this.flyoutForm.querySelectorAll("input[data-filter-item]")).filter(input => {
      if (input.hasAttribute("data-filter-reset")) {
        return false;
      }
      if (input.name === "sort_by") {
        return false;
      }
      return true;
    });
    const hasActiveFilters = filterInputs.some(input => {
      if (input.type === "checkbox") {
        return input.checked;
      }
      if (input.type === "number") {
        return input.value.trim() !== "";
      }
      return false;
    });
    filterInputs.forEach(input => {
      if (input.type === "checkbox" && input.checked) {}
      if (input.type === "number" && input.value.trim() !== "") {}
    });
    const isHidden = clearBtn.classList.contains(this.selectors.hideClass);
    const shouldBeHidden = !hasActiveFilters;
    if (isHidden !== shouldBeHidden) {
      if (shouldBeHidden) {
        clearBtn.classList.add(this.selectors.hideClass);
      } else {
        clearBtn.classList.remove(this.selectors.hideClass);
      }
    } else {}
  }
  handleClearClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const inputs = this.flyoutForm.querySelectorAll("input[data-filter-item]");
    let cleared = 0;
    inputs.forEach(input => {
      if (input.name === "sort_by") {
        return;
      }
      if (input.hasAttribute("data-filter-reset")) {
        if (!input.checked) {
          input.checked = true;
          cleared++;
        }
      } else if (input.type === "checkbox" && input.checked) {
        input.checked = false;
        cleared++;
      } else if (input.type === "number" && input.value.trim() !== "") {
        input.value = "";
        cleared++;
      }
    });
    this.updateClearButtonVisibility();
    const applyBtn = this.flyoutForm.querySelector(this.selectors.applyBtn);
    if (applyBtn) {
      applyBtn.click();
    }
  }
}
class FilterTopbarManager {
  constructor() {
    this.selectors = {
      topbarForm: "[data-filter-form-topbar]",
      filterInputs: "input[data-filter-item]",
      detailsWrapper: ".filter-dropdown__details"
    };
    this.topbarForm = document.querySelector(this.selectors.topbarForm);
    if (!this.topbarForm) {
      return;
    }
    this.init();
  }
  init() {
    this.topbarForm.addEventListener("change", e => {
      if (e.target.hasAttribute("data-filter-item")) {
        this.handleInputChange(e.target);
      }
    });
  }
  handleInputChange(input) {
    this.handleShowAllLogic(input);
  }
  handleShowAllLogic(input) {
    const isResetRadio = input.hasAttribute("data-filter-reset");
    const isFilterCheckbox = input.type === "checkbox" && !isResetRadio && input.name.includes("filter.");
    if (isResetRadio && input.checked) {
      const paramName = input.dataset.paramName;
      const checkboxes = this.topbarForm.querySelectorAll(`input[type="checkbox"][name="${paramName}"]`);
      checkboxes.forEach(box => {
        box.checked = false;
      });
    }
    if (isFilterCheckbox) {
      const paramName = input.name;
      if (input.checked) {
        const resetBtn = this.topbarForm.querySelector(`input[data-filter-reset][data-param-name="${paramName}"]`);
        if (resetBtn) {
          resetBtn.checked = false;
        }
      } else {
        const remainingChecked = this.topbarForm.querySelectorAll(`input[type="checkbox"][name="${paramName}"]:checked`).length;
        if (remainingChecked === 0) {
          const resetBtn = this.topbarForm.querySelector(`input[data-filter-reset][data-param-name="${paramName}"]`);
          if (resetBtn) {
            resetBtn.checked = true;
          }
        }
      }
    }
  }
}
class FilterSyncManager {
  constructor() {
    this.selectors = {
      topbarForm: "[data-filter-form-topbar]",
      flyoutForm: "[data-filter-form-flyout]",
      topbarApplyBtn: "[data-filter-form-topbar] [data-filter-apply]",
      topbarPopup: ".filter-dropdown__popup",
      topbarDetails: ".filter-dropdown__details",
      flyoutApplyBtn: '[data-filter-form-flyout] [data-button="apply"]',
      removeFilterBtn: "[data-remove-filter]",
      availabilityToggle: 'input[name="filter.v.availability"]'
    };
    this.topbarForm = document.querySelector(this.selectors.topbarForm);
    this.flyoutForm = document.querySelector(this.selectors.flyoutForm);
    if (!this.topbarForm || !this.flyoutForm) {
      return;
    }
    this.init();
  }
  init() {
    this.flyoutForm.addEventListener("change", e => {
      this.syncFlyoutToTopbar(e.target);
      this.syncDisabledStates();
    });
    this.topbarForm.addEventListener("change", e => {
      this.syncTopbarToFlyout(e.target);
    });
    this.topbarForm.addEventListener("click", e => {
      if (e.target.matches(this.selectors.topbarApplyBtn)) {
        this.handleTopbarApply(e);
      }
    });
    const availToggle = this.topbarForm.querySelector(this.selectors.availabilityToggle);
    if (availToggle) {
      availToggle.addEventListener("change", e => {
        this.syncTopbarToFlyout(e.target);
        this.triggerFlyoutChange(e.target);
        this.triggerFlyoutApply();
        this.syncDisabledStates();
      });
    }
    document.addEventListener("click", e => {
      const removeBtn = e.target.closest(this.selectors.removeFilterBtn);
      if (removeBtn) {
        this.handleRemoveFilter(e, removeBtn);
        return;
      }
      const clearBtn = e.target.closest("[data-clear]");
      if (clearBtn) {
        this.handleClearAll(e, clearBtn);
        return;
      }
    });
    document.addEventListener("theme:collection:updated", () => {
      this.syncDisabledStates();
    });
    this.initialSync();
  }
  syncFlyoutToTopbar(sourceInput) {
    if (!sourceInput.name && !sourceInput.hasAttribute("data-filter-item")) {
      return;
    }
    const valueEscaped = sourceInput.dataset.valueEscaped;
    if (sourceInput.hasAttribute("data-filter-reset")) {
      const paramName = sourceInput.dataset.paramName;
      const matchingTopbarInput = this.topbarForm.querySelector(`input[data-filter-reset][data-param-name="${paramName}"]`);
      if (matchingTopbarInput) {
        matchingTopbarInput.checked = sourceInput.checked;
      }
    } else if (sourceInput.name) {
      const matchingTopbarInput = this.topbarForm.querySelector(`input[name="${sourceInput.name}"][data-value-escaped="${valueEscaped}"]`);
      if (matchingTopbarInput) {
        if (sourceInput.type === "checkbox" || sourceInput.type === "radio") {
          matchingTopbarInput.checked = sourceInput.checked;
        } else {
          matchingTopbarInput.value = sourceInput.value;
        }
      }
    }
  }
  syncTopbarToFlyout(sourceInput) {
    if (!sourceInput.name && !sourceInput.hasAttribute("data-filter-item")) {
      return;
    }
    const valueEscaped = sourceInput.dataset.valueEscaped;
    if (sourceInput.hasAttribute("data-filter-reset")) {
      const paramName = sourceInput.dataset.paramName;
      const matchingFlyoutInput = this.flyoutForm.querySelector(`input[data-filter-reset][data-param-name="${paramName}"]`);
      if (matchingFlyoutInput) {
        matchingFlyoutInput.checked = sourceInput.checked;
      }
    } else if (sourceInput.name) {
      const matchingFlyoutInput = this.flyoutForm.querySelector(`input[name="${sourceInput.name}"][data-value-escaped="${valueEscaped}"]`);
      if (matchingFlyoutInput) {
        if (sourceInput.type === "checkbox" || sourceInput.type === "radio") {
          matchingFlyoutInput.checked = sourceInput.checked;
        } else {
          matchingFlyoutInput.value = sourceInput.value;
        }
      }
    }
  }
  syncDisabledStates() {
    const flyoutInputs = Array.from(this.flyoutForm.querySelectorAll("input[data-filter-item]"));
    let synced = 0;
    flyoutInputs.forEach(flyoutInput => {
      if (flyoutInput.hasAttribute("data-filter-reset") || flyoutInput.name === "sort_by") {
        return;
      }
      const valueEscaped = flyoutInput.dataset.valueEscaped;
      const isDisabled = flyoutInput.disabled;
      const topbarInput = this.topbarForm.querySelector(`input[name="${flyoutInput.name}"][data-value-escaped="${valueEscaped}"]`);
      if (topbarInput) {
        const wasDisabled = topbarInput.disabled;
        if (wasDisabled !== isDisabled) {
          topbarInput.disabled = isDisabled;
          synced++;
        }
      }
    });
  }
  handleTopbarApply(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const popup = e.target.closest(".filter-dropdown__popup");
    if (!popup) {
      return;
    }
    const detailsWrapper = popup.closest(".filter-dropdown")?.querySelector("details");
    if (detailsWrapper) {}
    const changedInputs = this.getTopbarChangedInputs(popup);
    changedInputs.forEach((input, index) => {
      this.syncTopbarToFlyout(input);
    });
    if (detailsWrapper) {
      detailsWrapper.removeAttribute("open");
    }
    this.triggerFlyoutApply();
    this.syncDisabledStates();
  }
  getTopbarChangedInputs(popup) {
    if (!popup) {
      return [];
    }
    const inputs = Array.from(popup.querySelectorAll("input[data-filter-item]"));
    inputs.forEach((input, index) => {});
    return inputs;
  }
  handleRemoveFilter(e, removeBtn) {
    const filterName = removeBtn.dataset.name;
    const filterValue = removeBtn.dataset.value;
    const filterValueEscaped = removeBtn.dataset.valueEscaped;
    const flyoutInput = this.flyoutForm.querySelector(`input[name="${filterName}"][data-value-escaped="${filterValueEscaped}"]`);
    if (flyoutInput) {
      flyoutInput.checked = false;
      flyoutInput.dispatchEvent(new Event("change", {
        bubbles: true
      }));
      this.triggerFlyoutApply();
    } else {}
  }
  handleClearAll(e, clearBtn) {
    e.preventDefault();
    const inputs = this.flyoutForm.querySelectorAll("input[data-filter-item]");
    let cleared = 0;
    inputs.forEach(input => {
      if (input.name === "sort_by") {
        return;
      }
      if (input.hasAttribute("data-filter-reset")) {
        if (!input.checked) {
          input.checked = true;
          cleared++;
        }
      } else if (input.type === "checkbox" && input.checked) {
        input.checked = false;
        cleared++;
      } else if (input.type === "number" && input.value.trim() !== "") {
        input.value = "";
        cleared++;
      }
    });
    this.initialSync();
    this.triggerFlyoutApply();
  }
  triggerFlyoutChange(topbarInput) {
    const valueEscaped = topbarInput.dataset.valueEscaped;
    const matchingFlyoutInput = this.flyoutForm.querySelector(`input[name="${topbarInput.name}"][data-value-escaped="${valueEscaped}"]`);
    if (matchingFlyoutInput) {
      matchingFlyoutInput.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    } else {}
  }
  triggerFlyoutApply() {
    const flyoutApplyBtn = this.flyoutForm.querySelector(this.selectors.flyoutApplyBtn);
    if (flyoutApplyBtn) {
      flyoutApplyBtn.click();
    } else {}
  }
  initialSync() {
    const flyoutInputs = this.flyoutForm.querySelectorAll("input[data-filter-item]");
    flyoutInputs.forEach((flyoutInput, index) => {
      this.syncFlyoutToTopbar(flyoutInput);
    });
  }
}
class FilterStateRestorationManager {
  constructor() {
    this.selectors = {
      topbarForm: "[data-filter-form-topbar]",
      flyoutForm: "[data-filter-form-flyout]",
      topbarDetails: ".filter-dropdown__details",
      flyoutDrawer: "[data-filter-flyout]",
      applyBtns: '[data-button="apply"], [data-filter-apply]'
    };
    this.topbarForm = document.querySelector(this.selectors.topbarForm);
    this.flyoutForm = document.querySelector(this.selectors.flyoutForm);
    if (!this.topbarForm || !this.flyoutForm) {
      return;
    }
    this.savedTopbarStates = new Map();
    this.savedFlyoutStates = new Map();
    this.init();
  }
  init() {
    const topbarDetails = this.topbarForm.querySelectorAll(this.selectors.topbarDetails);
    topbarDetails.forEach(details => {
      details.addEventListener("toggle", () => {
        if (details.open) {
          this.saveTopbarState(details);
        } else {
          this.restoreTopbarState(details);
        }
      });
    });
    this.topbarForm.addEventListener("click", e => {
      if (e.target.matches("[data-filter-apply]")) {
        this.savedTopbarStates.clear();
      }
    });
    const flyoutTriggers = document.querySelectorAll("[data-filter-open]");
    flyoutTriggers.forEach(trigger => {
      trigger.addEventListener("click", () => {
        this.saveFlyoutState();
      });
    });
    document.addEventListener("click", e => {
      const closeIcon = e.target.closest("[data-close-icon]");
      const wash = e.target.closest("[data-filter-wash]");
      if (closeIcon || wash) {
        this.restoreFlyoutState();
      }
    });
    this.flyoutForm.addEventListener("click", e => {
      if (e.target.matches('[data-button="apply"]')) {
        this.savedFlyoutStates.clear();
      }
    });
  }
  saveTopbarState(detailsElement) {
    const wrapper = detailsElement.closest(".filter-dropdown");
    if (!wrapper) {
      return;
    }
    const popup = wrapper.querySelector(".filter-dropdown__popup");
    if (!popup) {
      return;
    }
    const inputs = popup.querySelectorAll("input[data-filter-item]");
    const stateKey = detailsElement.id;
    const states = [];
    inputs.forEach(input => {
      const state = {
        name: input.name,
        value: input.value,
        checked: input.checked,
        valueEscaped: input.dataset.valueEscaped
      };
      states.push(state);
    });
    this.savedTopbarStates.set(stateKey, states);
  }
  restoreTopbarState(detailsElement) {
    const stateKey = detailsElement.id;
    const savedStates = this.savedTopbarStates.get(stateKey);
    if (!savedStates) {
      return;
    }
    const wrapper = detailsElement.closest(".filter-dropdown");
    const popup = wrapper.querySelector(".filter-dropdown__popup");
    if (!popup) {
      return;
    }
    let restored = 0;
    const inputs = popup.querySelectorAll("input[data-filter-item]");
    inputs.forEach(input => {
      const savedState = savedStates.find(s => s.name === input.name && s.valueEscaped === input.dataset.valueEscaped);
      if (savedState && input.checked !== savedState.checked) {
        input.checked = savedState.checked;
        restored++;
      }
    });
    if (restored > 0) {
      this.savedTopbarStates.delete(stateKey);
    } else {}
  }
  saveFlyoutState() {
    const inputs = this.flyoutForm.querySelectorAll("input[data-filter-item]");
    this.savedFlyoutStates.clear();
    inputs.forEach(input => {
      const state = {
        name: input.name,
        value: input.value,
        checked: input.checked,
        valueEscaped: input.dataset.valueEscaped
      };
      this.savedFlyoutStates.set(`${input.name}-${input.dataset.valueEscaped}`, state);
    });
  }
  restoreFlyoutState() {
    if (this.savedFlyoutStates.size === 0) {
      return;
    }
    let restored = 0;
    const inputs = this.flyoutForm.querySelectorAll("input[data-filter-item]");
    inputs.forEach(input => {
      const stateKey = `${input.name}-${input.dataset.valueEscaped}`;
      const savedState = this.savedFlyoutStates.get(stateKey);
      if (savedState && input.checked !== savedState.checked) {
        input.checked = savedState.checked;
        restored++;
      }
      if (savedState && input.value !== savedState.value) {
        input.value = savedState.value;
        restored++;
      }
    });
    if (restored > 0) {
      this.savedFlyoutStates.clear();
    } else {}
  }
}
class FilterKeyboardAccessibilityManager {
  constructor() {
    this.selectors = {
      topbarForm: "[data-filter-form-topbar]",
      topbarDetails: ".filter-dropdown__details",
      topbarSummary: ".filter-dropdown__trigger",
      topbarPopup: ".filter-dropdown__popup",
      topbarInputs: ".filter-dropdown__option input[data-filter-item]",
      topbarLabels: ".filter-dropdown__popup .filter-dropdown__option-label",
      flyoutForm: "[data-filter-form-flyout]",
      availabilityToggle: ".availability-toggle__label"
    };
    this.topbarForm = document.querySelector(this.selectors.topbarForm);
    this.flyoutForm = document.querySelector(this.selectors.flyoutForm);
    if (!this.topbarForm) {
      return;
    }
    this.currentFocusedDropdown = null;
    this.currentFocusedInputIndex = -1;
    this.init();
  }
  init() {
    this.topbarForm.addEventListener("keydown", e => {
      this.handleTopbarKeydown(e);
    });
    this.topbarForm.addEventListener("keydown", e => {
      if (e.target.matches(this.selectors.topbarLabels)) {
        this.handleLabelKeydown(e);
      }
    });
    const availLabels = document.querySelectorAll(this.selectors.availabilityToggle);
    availLabels.forEach(label => {
      label.addEventListener("keydown", e => {
        this.handleAvailabilityKeydown(e);
      });
    });
  }
  handleTopbarKeydown(e) {
    const summary = e.target.closest(this.selectors.topbarSummary);
    if (!summary) return;
    const details = summary.closest(this.selectors.topbarDetails);
    switch (e.key) {
      case "Enter":
      case " ":
        e.preventDefault();
        if (!details.open) {
          this.closeSiblings(details);
          details.setAttribute("open", "");
          this.focusFirstLabel(details);
        } else {
          details.removeAttribute("open");
          summary.focus();
        }
        break;
      case "Escape":
        if (details.open) {
          details.removeAttribute("open");
          summary.focus();
        }
        break;
    }
  }
  handleLabelKeydown(e) {
    const label = e.target;
    const input = document.getElementById(label.getAttribute("for"));
    if (!input) return;
    const labels = Array.from(label.closest(".filter-dropdown__popup").querySelectorAll(this.selectors.topbarLabels));
    const idx = labels.indexOf(label);
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        labels[(idx + 1) % labels.length].focus();
        break;
      case "ArrowUp":
        e.preventDefault();
        labels[(idx - 1 + labels.length) % labels.length].focus();
        break;
      case "Enter":
      case " ":
        e.preventDefault();
        input.checked = !input.checked;
        label.setAttribute("aria-pressed", input.checked);
        input.dispatchEvent(new Event("change", {
          bubbles: true
        }));
        break;
      case "Escape":
        const details = label.closest(".filter-dropdown__details");
        if (details) {
          details.removeAttribute("open");
          details.querySelector(this.selectors.topbarSummary).focus();
        }
        break;
    }
  }
  handleAvailabilityKeydown(e) {
    const input = e.target.closest(this.selectors.availabilityToggle)?.querySelector("input");
    if (!input) return;
    switch (e.key) {
      case "Enter":
      case " ":
        e.preventDefault();
        input.checked = !input.checked;
        input.dispatchEvent(new Event("change", {
          bubbles: true
        }));
        break;
    }
  }
  focusFirstLabel(details) {
    const lbl = details.querySelector(this.selectors.topbarLabels);
    if (lbl) {
      lbl.focus();
    } else {}
  }
  closeSiblings(currentDetails) {
    document.querySelectorAll(this.selectors.topbarDetails).forEach(details => {
      if (details !== currentDetails && details.open) {
        details.removeAttribute("open");
      }
    });
  }
}
function updateFilteringCount() {
  var gridHidden = document.querySelector('.collection__window--until-filter-hidden');
  if (gridHidden != null) {
    gridHidden.classList.remove("collection__window--until-filter-hidden");
  }
  const countSource = document.querySelector(".collection-flyout__title [data-source-filter-count]");
  if (!countSource) {
    return;
  }
  const countText = countSource.textContent.trim();
  const countTargets = document.querySelectorAll("[data-filtering-count]");
  if (countTargets.length === 0) {
    return;
  }
  countTargets.forEach((target, index) => {
    const oldText = target.textContent;
    target.textContent = countText;
  });
}
document.addEventListener("DOMContentLoaded", () => {
  new FilterUIManager();
  new FilterTopbarManager();
  new FilterFlyoutManager();
  new FilterStateRestorationManager();
  new FilterSyncManager();
  new FilterKeyboardAccessibilityManager();
  document.addEventListener("theme:collection:updated", () => {
    updateFilteringCount();
  });
});
var url = window.location.href;
setInterval(function () {
  if (url != window.location.href) {
    fetch(window.location.href).then(r => r.text()).then(b => {
      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(b, "text/html");
      var total = htmlDoc.querySelector('[data-filtering-count]');
      if (total != null) {
        document.querySelectorAll('[data-filtering-count]').forEach(f => {
          f.innerHTML = total.innerHTML;
        });
      }
    });
    url = window.location.href;
  }
}, 100);
function getFilterParams() {
  var params = "";
  document.querySelectorAll('[data-filter-form-flyout] input').forEach(e => {
    if (e.checked) {
      params += `${e.name}=${e.value}&`;
    }
  });
  return params;
}
function filterchange(element) {
  var params = getFilterParams();
  if (params.length > 1) {
    fetch(window.location.pathname + "?" + params).then(r => r.text()).then(b => {
      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(b, "text/html");
      var updatedhtml = htmlDoc.querySelector('.collection-flyout__content');
      var i = 0;
      document.querySelectorAll('.plp-accordion__item').forEach(e => {
        updatedhtml.querySelectorAll('.plp-accordion__inner')[i].setAttribute("data-updated", true);
        e.querySelector('.plp-accordion__inner').innerHTML = updatedhtml.querySelectorAll('.plp-accordion__inner')[i].innerHTML;
        i++;
      });
    });
  }
}
function setavailablenow(element) {
  setTimeout(() => {
    var params = getFilterParams();
    window.collectionModule._renderView(params);
    window.collectionModule._updateURLHash(params);
  });
}